import React from 'react';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="logo">
          CodeTogether
        </h1>
        <p className="tagline">Real-time Collaborative Code Editor</p>
      </div>
    </header>
  );
}

export default Header;